import {
  GET_CLIENT_TESTIMONIALS_SUCCESS,
  GET_CLIENT_TESTIMONIALS_FAILURE,
} from '../constants/actionTypes';

const INITIAL_STATE = {
  data: [],
  error: null
};

export default function clientTestimonials(state = INITIAL_STATE, action) {
  switch (action.type) {
    case GET_CLIENT_TESTIMONIALS_SUCCESS:
      return { ...state, data: action.payload.data };
    case GET_CLIENT_TESTIMONIALS_FAILURE:
    default:
      return state;
  }
}
